<template>
	<div class="item">
		<div class="quantity">
			<a class="change" @click="change('subtract')">-</a>
			<div class="amount" v-text="quantity"/>
			<a class="change" @click="change('add')">+</a>
		</div>
		<div v-text="title"/>
		<div>{{price / 100}}</div>
	</div>
</template>

<script>
import store from '../../store';
export default {
	store,
	props: {
		title: {type: String, required: true},
		quantity: {type: Number, required: true},
		variant_id: {type: Number, required: true},
		price: {type: Number, required: true}
	},
	methods: {
		async change(action) {
			const quantity = action === 'add' ? this.quantity+1 : this.quantity-1;
			await this.$store.dispatch('cart/change', {id: this.variant_id, quantity});
		}
	}
}
</script>

<style lang="scss" scoped>
.item {
	margin-bottom: 20px;
	.quantity {
		display: flex;
		align-items: center;
	}
	.amount {
		margin: 0 5px;
	}
	.change {
		cursor: pointer;
	}
}
</style>

